import { render } from "./ExpectationsTable.vue?vue&type=template&id=fd4f890c"
import script from "./ExpectationsTable.vue?vue&type=script&lang=js"
export * from "./ExpectationsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__